/**
 * A cobranca do plano por mes, com o nome que a API manda (spec 064): na Prop e a "Mensalidade" (a resposta nao traz
 * `rotulo`), na Global a "Taxa de manutenção", em dolar com o real pela cotacao. So formata o que veio; o valor, a
 * cotacao e a situacao sao do backend.
 */
import { formatarDolares, formatarReais } from "@mtc/ui";

/** O nome da cobranca pra tela: o da API ou "Mensalidade". */
export const nomeDaCobranca = (rotulo?: string | null) => rotulo || "Mensalidade";

/** "Mensalidades" (titulo da pagina da Prop) ou o nome que a API mandou ("Taxa de manutenção"). */
export const tituloDaCobranca = (rotulo?: string | null) => rotulo || "Mensalidades";

/** A cotacao como a API manda ("5.1527") escrita como se le ("5,1527"). */
export const cotacaoLegivel = (c: string) => c.replace(".", ",");

/** O valor de uma parcela: em reais; em dolar, "US$ 9,00 (R$ 46,38)", ou so o dolar enquanto a cotacao nao saiu. */
export function valorDaParcela(p: { valor_centavos: number | null; valor_usd_centavos?: number | null }, semValor = "A definir"): string {
  if (p.valor_usd_centavos != null) return p.valor_centavos != null ? `${formatarDolares(p.valor_usd_centavos)} (${formatarReais(p.valor_centavos)})` : formatarDolares(p.valor_usd_centavos);
  return p.valor_centavos != null ? formatarReais(p.valor_centavos) : semValor;
}
